import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { useHttpClient } from '../../client/HttpClientContext';
export const useCachedResolver = (referenceType, objectTypeId, options) => {
  const httpClient = useHttpClient();
  return createStandardCachedResolver(referenceType, objectTypeId, Object.assign({}, options, {
    httpClient
  }));
};